var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"empty",class:_vm.type},[_c('div',{staticClass:"empty-icon"},[_c('svg-icon',{attrs:{"source":_vm.icon}})],1),_vm._v(" "),_c('div',{staticClass:"empty-text",domProps:{"innerHTML":_vm._s(_vm.text)}})])}
var staticRenderFns = []

export { render, staticRenderFns }